const initialState = {
  anchor: 'left',
  pais: [],
  open: false,
  id: '',
  nome: '',
  nomePt: '',
  iso2: '',
  iso3: '',
  bacen: '',
}

export function pais(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_PAIS':
      return {
        ...state,
        pais: action.pais
      }
    case 'PAIS_DETAIL':
      return {
        ...state,
        id: action.id,
        nome: action.nome,
        uf: action.uf,
        ibge: action.ibge,
        paisId: action.paisId,
        ddd: action.ddd
      }
    case 'PAIS_UPDATED':
      return state
    case 'HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    default:
      return state
  }
}
